.dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.synced {
  background: var(--tuna-feedback-success);
}

.syncing {
  background: var(--tuna-feedback-warning);
}

.offline {
  background: var(--tuna-content-secondary);
}
